import { apiClient } from './client';

/** Debe reflejar los ids reales de aws-serverless/src/modules/*.module.ts —
 *  ver docs/agromodules-diccionario.md para la lista completa y su propósito. */
export const KNOWN_AGRO_MODULE_IDS = [
  'users', 'rancho-lote', 'support', 'developer', 'operations', 'calendar', 'weather',
  'inventory', 'finance', 'crop-management', 'resources', 'traceability', 'irrigation',
  'drone', 'protocol', 'harvest', 'porcino', 'transport', 'payroll', 'merma', 'export',
  'sales', 'vocabulary', 'machinery',
] as const;

export interface AgroModulesConfig {
  enabledAgroModules: string[] | null; // null = todos habilitados
  notifyDisabledModules: boolean;
}

export const fetchAgroModulesConfig = async (): Promise<AgroModulesConfig> =>
  (await apiClient.get('/api/settings/agro-modules')).data;

export const updateAgroModulesConfig = async (patch: Partial<AgroModulesConfig>): Promise<AgroModulesConfig> =>
  (await apiClient.patch('/api/settings/agro-modules', patch)).data;
